import React from 'react';
import { motion } from 'framer-motion';
export function Mission() {
  return <section className="w-full bg-navy-primary py-12 md:py-20 px-4 md:px-6" data-id="element-164">
      <div className="max-w-4xl mx-auto" data-id="element-165">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-166">
          <blockquote className="text-lg md:text-2xl text-white leading-relaxed italic mb-6 md:mb-8" data-id="element-167">
            "เราสร้างระบบนี้เพื่ออาจารย์สอนฟุตบอลไทย
            ที่ทำงานหนักแต่ยังไม่เห็นผลลัพธ์ที่ต้องการ
            <br data-id="element-168" />
            <br data-id="element-169" />
            ไม่มีทฤษฎี ไม่มีที่ปรึกษาราคาแพง มีแต่เครื่องมือที่ใช้งานได้จริง
            เพื่อให้คุณสอนฟุตบอลได้อย่างมืออาชีพอย่างแท้จริง"
          </blockquote>
          <p className="text-gold-accent font-bold text-lg md:text-xl" data-id="element-170">
            — ทีมงาน ฟุตบอล พร้อม
          </p>
        </motion.div>
      </div>
    </section>;
}